import { createContext, useState } from "react";

export type SetState<T> = React.Dispatch<React.SetStateAction<T>>;

export interface DisabledContextProps {
  isDisabled: boolean;
  setIsDisabled: SetState<boolean>;
}

export const DisabledContext = createContext<DisabledContextProps | undefined>(
  undefined
);

interface Props {
  children: React.ReactNode;
  isDisabled?: boolean;
}

export const DisabledContextProvider: React.FC<Props> = (props) => {
  const { children, isDisabled } = props;

  // local state for context
  const [isDisabledinternal, setIsDisabledinternal] = useState<boolean>(false);

  return (
    <DisabledContext.Provider
      value={{
        isDisabled: isDisabled ?? isDisabledinternal,
        setIsDisabled: setIsDisabledinternal,
      }}
    >
      {children}
    </DisabledContext.Provider>
  );
};
